const API = process.env.REACT_APP_BACKEND_URL;
export const CDN = 'https://cdn.opinly.ai/YEtTwb1BhkK6Uqx6aGTU0';
export const BLOG = '/blog';
export const PATHS = {
  index: BLOG,
  post: (slug) => `${BLOG}/${slug}`,
  category: (slug) => `${BLOG}/kategorie/${slug}`,
  author: (slug) => `${BLOG}/autor/${slug}`,
  authors: `${BLOG}/autoren`,
  tag: (slug) => `${BLOG}/tag/${slug}`,
};

export const imageUrl = (fileKey) => (fileKey ? (fileKey.startsWith('http') ? fileKey : `${CDN}/${fileKey}`) : null);

export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' }) : '');

export class BlogError extends Error {
  constructor(message, status) { super(message); this.status = status; }
}

async function get(path, params = {}) {
  const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''));
  const res = await fetch(`${API}/api/blog${path}${q.toString() ? `?${q}` : ''}`);
  if (!res.ok) {
    let detail = 'Inhalte konnten nicht geladen werden.';
    try { detail = (await res.json()).detail || detail; } catch (err) { console.warn('[blog] non-JSON error response', res.status); }
    throw new BlogError(detail, res.status);
  }
  return res.json();
}

export const blogApi = {
  posts: (params) => get('/posts', { limit: 12, sort: 'newest', ...params }),
  post: (slug) => get('/post', { slug }),
  categories: () => get('/categories'),
  authors: () => get('/authors'),
  author: (slug) => get(`/authors/${encodeURIComponent(slug)}`),
};

export const readingTime = (node) => {
  let words = 0;
  const walk = (n) => { if (!n) return; if (n.text) words += n.text.split(/\s+/).filter(Boolean).length; (n.content || []).forEach(walk); };
  walk(node);
  return Math.max(1, Math.round(words / 200));
};
